var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 4.5L18.4996 0C2.09964 2 -0.333696 17.5 0.499637 25C1.29964 34.2 8.49964 35.8333 11.9996 35.5C21.5996 35.1 22.333 27 21.4996 23C20.2996 15 13.333 14 9.99964 14.5C10.3996 8.9 16.833 5.5 19.9996 4.5Z",
    fill: "#EAE3ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6422 4.5L44.1422 0C27.7422 2 25.3089 17.5 26.1422 25C26.9422 34.2 34.1422 35.8333 37.6422 35.5C47.2422 35.1 47.9755 27 47.1422 23C45.9422 15 38.9755 14 35.6422 14.5C36.0422 8.9 42.4755 5.5 45.6422 4.5Z",
    fill: "#EAE3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteTest);
export default __webpack_public_path__ + "static/media/quote-test.e61550e28bb298bb395a507bf97e3dae.svg";
export { ForwardRef as ReactComponent };